import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { PhoneInput } from "react-international-phone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "react-bootstrap/Tooltip";
import JobDescription from "../../RecrtProcess/candidate/component/job-description-dropdown-edit";
import ReactDatePicker from "react-datepicker";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import RatingComponent from "../../../../components/RatingComponent";
import RatingComponentWithoutNa from "../../../../components/RatingComponentWithoutNA";
import Editor from "../../../../components/editor";
import HrDropdown from "../../RecrtProcess/candidate/component/hrdropdown";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileUploader from "../../../../components/FileUploader";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import * as Yup from "yup";
import { X } from "lucide-react";

const ResumeParserEdit = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  const [refferralDetails, setReferralInput] = useState({
    show: false,
    label: "",
    placeholder: "",
  });
  const [referrals, setReferrals] = useState([]);
  const { id } = useParams();
  let [errors, setErrors] = useState({});
  console.log("errors", errors);

  const [FileName, setFileName] = useState(undefined);
  const [NoOfProjectContent, setNoOfProjectContent] = useState("");
  console.log("NoOfProjectContent", NoOfProjectContent);

  const [roleOfProjectContent, setRoleOfProjectContent] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [jsonData, setJsonData] = useState(null);
  const [selectedJobTitle, setSelectedJobTitle] = useState({});
  const [jobtitleOption, setJobTitleOption] = useState({});
  const [hrOptions, setHrOptions] = useState([]);
  const [gender_option, setGenderOption] = useState([]);
  const [source_option, setSourceOption] = useState([]);
  const [showOthersInput, setShowOthersInput] = useState(false);
  const [showCampusInput, setShowCampusInput] = useState(false);
  const [showJobPortalInput, setShowJobPortalInput] = useState(false);
  const [candidateProcessed, setSelected] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  console.log("resumeFile", resumeFile);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const handleAdditionalInputChange = (show) => {
    setShowOthersInput(show);
    setShowCampusInput(show);
    setShowJobPortalInput(show);
  };

  const notice_period = [
    { value: "", label: "Select..." },
    { value: "0", label: "0" },
    { value: "15", label: "15" },
    { value: "30", label: "30" },
    { value: "45", label: "45" },
    { value: "60", label: "60" },
    { value: "75", label: "75" },
    { value: "90", label: "90" },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Resume Parser"));
  }, []);
  // status section
  const [statusOption, setStatusOption] = useState();
  const [statusData, setStatusData] = useState([]);

  let today = moment().format("DD-MMM-YYYY");
  const initialFormData = {
    JobDescriptionID: "",
    JobMasterID: null,
    AppliedDate: today || "",
    RecruiterID: "",
    FirstName: "",
    LastName: "",
    Gender: "",
    EmailID: "",
    DateOfBirth: "",
    MobileNo: "",
    MobileNo1: "",
    SkillSet: [],
    SubSkillSet: "",
    IntroduceYourself: null,
    OralSkills: null,
    Accent: null,
    CurrentCompanyName: "",
    CurrentPosition: "",
    CurrentExperienceInYears: "",
    CurrentRelevantExperienceInYears: "",
    Qualifications: "",
    NoticePeriod: "",
    NoticePeriodExtractedText: "",
    CurrentCTC: "",
    ExpectedCTC: "",
    ProjectOtherDesc: "",
    ProjectDetails: "",
    ProjectExamples: "",
    OtherChallenges: "",
    AreaDashboard: null,
    AreaArchitecture: null,
    AreaSDK: null,
    AreaReport: null,
    AreaAdministration: null,
    AreaOtherSkill: null,
    CurrentLocation: "",
    hr: "",
    OtherOptionValue: "",
    PreferredLocation: "",
    ReasonForChange: "",
    ReferralNote: "",
    WillingToTravel: "",
    LeadCandidateStatus_189: "",
    CandidateReferralType_174: "",
    referralType: "",
    CurrentJobDescription: "",
    ResumePath: "",
    ResumeBasePath: "",
    SubSkill: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);

  const handleCheckboxChange = (value) => {
    let updatedOptions;
    let workDomainSelectedOption = formData.WorkDomainIDs
      ? formData.WorkDomainIDs.split(",")
      : [];

    if (workDomainSelectedOption.length > 0) {
      if (workDomainSelectedOption.includes(value.toString())) {
        updatedOptions = workDomainSelectedOption.filter(
          (option) => option != value
        );
      } else {
        updatedOptions = [...workDomainSelectedOption, value];
      }
    } else {
      updatedOptions = [value];
    }

    setSelectedOptions(updatedOptions);

    // Update WorkDomainIDs in formData as a comma-separated string
    const updatedFormData = { ...formData };
    updatedFormData.WorkDomainIDs =
      updatedOptions.length > 0 ? updatedOptions.join(",") : "";
    setFormData(updatedFormData);
  };
  const validationSchema = Yup.object().shape({
    JobMasterID: Yup.mixed()
      .test("is-valid-object", "Job Title is required", (value) => {
        // Allow null only if it's the initial state
        if (value === null) return false;

        // Check if it's a valid object with value property
        return value && typeof value === "object" && value.value;
      })
      .required("Job Title is required"),
    RecruiterID: Yup.mixed()
      .test("is-valid-object", "HR login is required to proceed", (value) => {
        // Allow null only if it's the initial state
        if (value === null) return false;

        // Check if it's a valid object with value property
        return value && typeof value === "object" && value.value;
      })
      .required("HR login is required to proceed"),


    AppliedDate: Yup.string().required("Applied Date is required"),
    // RecruiterID: Yup.object()
    //   .shape({
    //     value: Yup.string().required("HR Name is required"),
    //     label: Yup.string()
    //   })
    // .required("HR Name is required"),
    FirstName: Yup.string()
      .matches(/^[a-zA-Z\s]*$/, "Only alphabetic characters are allowed")
      .required("First Name is required"),
    LastName: Yup.string()
      .matches(/^[a-zA-Z\s]*$/, "Only alphabetic characters are allowed")
      .required("Last Name is required"),
    PreferredLocation: Yup.string()
      .matches(/^[a-zA-Z\s]*$/, "Only alphabetic characters are allowed")
      .required("Joining Location is required"),
    // Update your validation schema
    Gender: Yup.object()
      .shape({
        value: Yup.string().required("Gender is required"),
        label: Yup.string(),
      })
      .nullable()
      .required("Gender is required")
      .test("is-object", "Gender is required", (value) => {
        return (
          value !== null && value !== undefined && value.value !== undefined
        );
      }),
    EmailID: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    // DateOfBirth: Yup.string()
    //   .required("Date of Birth is required")
    //   .test("is-valid-date", "Date of Birth is required", (value) => {
    //     return value !== null && value !== "";
    //   }),
    MobileNo: Yup.string()
      // .matches(/^\d{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
    MobileNo1: Yup.string()
      .nullable()
      .test(
        "is-10-digits",
        "Alternate Contact No. must be 10 digits",
        (value) => {
          if (!value) return true; // allow empty
          return /^\d{10}$/.test(value);
        }
      ),
    CurrentPosition: Yup.string().required("Designation is required"),
    SkillSet: Yup.array()
      .min(1, "At least one skill is required")
      .required("Skills are required"),
    CandidateReferralType_174: Yup.object()
      .shape({
        value: Yup.string().required("Source is required"),
        label: Yup.string(),
      })
      .required("Source is required"),
  });

  const [activeKey, setActiveKey] = useState("0");
  const [skillsetOptions, setskillsetOptions] = useState([]);
  const [subSkillOptions, setsubSkillOptions] = useState([]);
  const handleEditorChangeNoOfProject = (content) => {
    setNoOfProjectContent(content);
    setFormData((prev) => ({
      ...prev,
      ProjectOtherDesc: content,
    }));
  };

  const handleEditorChangeRoleOfProject = (content) => {
    setRoleOfProjectContent(content);
  };
  const handleRadioChange = (e) => {
    setFormData({
      ...formData,
      WillingToTravel: e.target.value,
    });
  };

  const handleRatingChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [mobileNoError, setMobileNoError] = useState("");
  const handleChange = (event) => {
    const { name, value } = event.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: { status: false, message: "" },
    }));
    // Basic validation for specific fields
    if (
      name === "CurrentExperienceInYears" ||
      name === "CurrentRelevantExperienceInYears"
    ) {
      if (!/^\d{0,2}$/.test(value)) return;
    } else if (name === "FirstName" || name === "LastName") {
      if (!/^[a-zA-Z\s]*$/.test(value)) return;
    } else if (name === "MobileNo") {
      if (!/^\d{0,10}$/.test(value)) return;
    } else if (name === "MobileNo1") {
      // Only allow digits and limit to 10 characters
      if (!/^\d{0,10}$/.test(value)) return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const [isDuplicate, setIsDuplicate] = useState({
    EmailID: false,
    MobileNo: false,
  });
  const [checkDuplicateErrmsg, setCheckDuplicateErrmsg] = useState({
    EmailID: "",
    MobileNo: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check duplicate status before submitting
    if (isDuplicate.EmailID || isDuplicate.MobileNo) {
      if (isDuplicate.EmailID) {
        toast.error(checkDuplicateErrmsg.EmailID || "Email already exists");
      }
      if (isDuplicate.MobileNo) {
        toast.error(
          checkDuplicateErrmsg.MobileNo || "Mobile number already exists"
        );
      }
      return;
    }
    if (formData.Qualifications && formData.Qualifications.length > 200) {
      toast.error("Qualifications must not exceed 200 characters");
      return;
    }
    if (
      formData.PreferredLocation &&
      formData.PreferredLocation.split(",").length > 1
    ) {
      toast.error("Only one joining location is allowed");
      return;
    }
    try {
      // Validate form with Yup
      await validationSchema.validate(formData, { abortEarly: false });
      setSubmit(true);
      if (![46, 47, 1401].includes(statusOption)) {
        toast.error("Status is Required");
        return;
      }

      // Remove SubSkill, ResumeBasePath, NoticePeriodExtractedText from formData
      const { SubSkill, ResumeBasePath, ResumePath, ...restFormData } =
        formData;

      const updatedFormData = {
        ...restFormData,
        Gender:
          typeof formData.Gender === "object"
            ? formData.Gender.value
            : formData.Gender,
        CandidateReferralType_174:
          typeof formData.CandidateReferralType_174 === "object"
            ? formData.CandidateReferralType_174.value
            : formData.CandidateReferralType_174,
        NoticePeriod:
          typeof formData.NoticePeriod === "object"
            ? formData.NoticePeriod.label
            : formData.NoticePeriod,
        JobDescriptionID: "",
        hr: "",
        ProjectOtherDesc: NoOfProjectContent,
        ProjectDetails: roleOfProjectContent,
        // LeadCandidateStatus_189: statusOption,
        LeadCandidateStatus_189: statusOption,
        RecruiterID: formData.RecruiterID?.value,
        JobMasterID: formData.JobMasterID?.value,
        referralType: formData.referralType?.value,
        SubSkillSet: formData.SubSkill,
        ProjectOtherDesc: formData?.ProjectOtherDesc,
        ProjectWork: formData?.ProjectOtherDesc,
        // ResumePath: resumeFile ? resumeFile : formData.ResumePath,
        // ResumePath: formData.ResumePath,
        ResumePath: "",
      };

      try {
        const response = await PostFormServiceCaller(
          API_URL + "ai-parsed-candidate-details/" + id,
          { ...updatedFormData, flag: 0 },
          "put"
        );
        if (response?.status === 202) {
          setPendingFormData(updatedFormData);
          setShowConfirmModal(true);
          setSubmit(false);
          return;
        }

        if (response?.data?.status == "success") {
          // toast.success(response?.data?.message);
          if (statusOption === 46) {
            navigate("/hrinterviews");
          } else if (statusOption === 47) {
            navigate("/candidate-in-process");
          } else if (statusOption === 1401) {
            navigate("/resume-parser");
          } else {
            toast.error("Invalid status selected");
          }
        }

        setSubmit(false);
      } catch (error) {
        setSubmit(false);
        console.error("Something went wrong");
      } finally {
        setSubmit(false);
      }
    } catch (validationErrors) {
      if (validationErrors.inner && validationErrors.inner.length > 0) {
        const newErrors = {};
        const shownMessages = new Set();

        validationErrors.inner.forEach((error) => {
          newErrors[error.path] = { status: true, message: error.message };

          if (!shownMessages.has(error.message)) {
            toast.error(error.message); // show only once
            shownMessages.add(error.message);
          }
        });

        setErrors(newErrors);
      }
    } finally {
      setSubmit(false);
    }
  };

  const handleEmailMobileVerify = async (e) => {
    e.stopPropagation();
    const { name, value } = e.target;

    // Clear previous errors and reset duplicate status for this field
    setErrors((prev) => ({ ...prev, [name]: { status: false, message: "" } }));
    setIsDuplicate((prev) => ({ ...prev, [name]: false }));
    setCheckDuplicateErrmsg((prev) => ({ ...prev, [name]: "" }));

    // Update form data
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Validate email format
    if (name === "EmailID") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          EmailID: { status: true, message: "Invalid email format" },
        }));
        return;
      }
    }

    // Validate mobile format
    if (name === "MobileNo") {
      const mobileRegex = /^[0-9]{10}$/;
      if (!mobileRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          MobileNo: {
            status: true,
            message: "Invalid mobile number (10 digits required)",
          },
        }));
        return;
      }
    }

    // Get current values
    const currentEmail = name === "EmailID" ? value : formData.EmailID;
    const currentMobile = name === "MobileNo" ? value : formData.MobileNo;

    // Skip API if both fields are empty
    if (!currentEmail && !currentMobile) return;

    try {
      const response = await PostServiceCaller(
        `${API_URL}check-duplicates`,
        {
          EmailID: name === "EmailID" ? value : null,
          MobileNo: name === "MobileNo" ? value : null,
        },
        "post"
      );

      const res = response?.data;

      if (res?.status === "unique") {
        setIsDuplicate((prev) => ({ ...prev, [name]: false }));
        setCheckDuplicateErrmsg((prev) => ({ ...prev, [name]: "" }));
      } else if (res?.status === "failed") {
        setIsDuplicate((prev) => ({ ...prev, [name]: true }));
        const errorMsg =
          res.message ||
          (name === "EmailID"
            ? "Email already exists"
            : "Mobile number already exists");
        setCheckDuplicateErrmsg((prev) => ({ ...prev, [name]: errorMsg }));
        toast.error(errorMsg);
      }
    } catch (error) {
      toast.error("Server error while checking duplicates");
    }
  };
  const handleDateChange = (date, field) => {
    const formattedDate = moment(date).format("DD-MMM-YYYY");
    setFormData({ ...formData, [field]: formattedDate });
  };

  const fetchData = async (id) => {
    try {
      // fetching parallelly
      const response = await GetServiceCaller(
        API_URL + "ai-parsed-candidate-details/" + id
      );

      let led_candidate_data = response?.data?.data?.aiparsedData;
      console.log("led_candidate_data", led_candidate_data);

      // Gender List
      const gender_options = response?.data?.data?.gender?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setGenderOption(gender_options);
      const selected_gender = gender_options?.find(
        (o) => o.value == led_candidate_data?.Gender
      );
      console.log("selected_gender", selected_gender);

      //HR List
      const hrOptions = response?.data?.data?.hr?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setHrOptions(hrOptions);
      // let selectedHr = hrOptions?.find(
      //   (o) => o.value == led_candidate_data?.RecruiterID
      // );
      //Job Title List
      const jobtitleOption = response?.data?.data?.jobtitle?.map((option) => ({
        value: option.value.toString(),
        label: option.text,
        JobCode: option.RequisitionCode || "",
        JobDescriptionID: option.JobDescriptionID
      }));
      setJobTitleOption(jobtitleOption);
      let selectedJobTitle = jobtitleOption?.find(
        (o) => o.value == led_candidate_data.JobDescriptionID
      );
      //Notice period list
      const selected_notice_period = notice_period?.find(
        (o) => o.value == led_candidate_data.NoticePeriod
      );
      //source list
      const source_options = response?.data?.data?.source?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setSourceOption(source_options);
      const selected_source = source_options?.find(
        (o) => o.value == led_candidate_data?.CandidateReferralType_174
      );
      if (led_candidate_data?.LeadCandidateStatus_189 == 47) {
        setSelected(true);
      }

      //Skill list
      const skillData = response?.data?.data?.Skill;
      const options_skills = skillData?.map((skill) => ({
        value: skill.ID,
        label: skill.Name,
      }));
      setskillsetOptions(options_skills);
      const selectedSkills = parseSelectedOptions(
        led_candidate_data.SkillSet,
        options_skills
      );
      // subskill option
      const subSkillData = response?.data?.data?.subskill;
      const options_subskills = subSkillData?.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      setsubSkillOptions(options_subskills);
      // let sub_skill_selected = [];
      // led_candidate_data.SubSkillSet?.split(",").forEach((element) => {
      //   sub_skill_selected.push(
      //     options_subskills.find((o) => o.value == element)
      //   );
      // });
      let selectedReferralType;
      let inputStateMap = [2035, 2034, 2037, 6768, 2036];

      if (
        inputStateMap.includes(led_candidate_data.CandidateReferralType_174)
      ) {
        let label = ["Reference", "Job Portal", "Others", "Campus", "Vendor"];
        let selected = inputStateMap.indexOf(
          Number(led_candidate_data.CandidateReferralType_174)
        );
        if (selected >= 0) {
          const response = await GetServiceCaller(
            API_URL + "get-referred-by-value/" + inputStateMap[selected]
          );
          const referrealsOptions = response?.data?.referrals?.map(
            (option) => ({
              value: option.VALUE,
              label: option.TEXT,
            })
          );
          setReferrals(referrealsOptions);
          setReferralInput({
            show: true,
            label: label[selected],
            placeholder: label[selected],
          });
          selectedReferralType = referrealsOptions?.find(
            (o) => o.value == led_candidate_data.ReferralID
          );
        } else {
          setReferralInput({ show: false, label: "", placeholder: "" });
        }
      } else {
      }
      if (
        led_candidate_data?.LeadCandidateStatus_189 == 47 ||
        led_candidate_data?.LeadCandidateStatus_189 == 46
      ) {
        setSelected(true);
      }
      const user = JSON.parse(localStorage.getItem("user"));
      const EmployeeID = user?.ID;
      let HumanResource = hrOptions?.find((o) => o.value == EmployeeID);
      let subSkillSetArray = led_candidate_data?.SubSkillSet;
      console.log("subSkillSetArray", subSkillSetArray);

      const formDataEdit = {
        JobMasterID: selectedJobTitle || "",
        AppliedDate: moment(led_candidate_data?.AppliedDate).format(
          "DD-MMM-YYYY"
        ),
        FirstName: led_candidate_data?.FirstName || "",
        LastName: led_candidate_data?.LastName || "",
        DateOfBirth:
          led_candidate_data?.DateOfBirth &&
            led_candidate_data.DateOfBirth !== "Invalid date"
            ? moment(led_candidate_data.DateOfBirth).format("DD-MMM-YYYY")
            : "",
        MobileNo: led_candidate_data?.MobileNo || "",
        MobileNo1: led_candidate_data?.MobileNo1 || "",
        Gender: selected_gender,
        EmailID: led_candidate_data?.EmailID || "",
        CurrentCompanyName: led_candidate_data?.CurrentCompanyName || "",
        CurrentPosition: led_candidate_data?.CurrentPosition || "",
        Qualifications: led_candidate_data?.Qualifications || "",
        CurrentCTC: Number(led_candidate_data?.CurrentCTC || 0).toFixed(2),
        ExpectedCTC: Number(led_candidate_data?.ExpectedCTC || 0).toFixed(2),
        CurrentExperienceInYears: Number(
          led_candidate_data?.CurrentExperienceInYears || 0
        ),
        CurrentRelevantExperienceInYears: Number(
          led_candidate_data?.CurrentRelevantExperienceInYears || 0
        ),
        PreferredLocation: led_candidate_data?.PreferredLocation || "",
        CurrentLocation: led_candidate_data?.CurrentLocation || "",
        ReasonForChange: led_candidate_data?.ReasonForChange || "",
        ReferralNote: led_candidate_data?.ReferralNote || "",
        RecruiterID: HumanResource || "",
        ProjectOtherDesc: led_candidate_data?.ProjectWork || "",
        IntroduceYourself: led_candidate_data?.IntroduceYourself || "",
        CurrentJobDescription: led_candidate_data?.CurrentJobDescription || "",
        OralSkills: led_candidate_data?.OralSkills || "",
        Accent: led_candidate_data?.Accent || "",
        AreaDashboard: led_candidate_data?.AreaDashboard || "",
        AreaArchitecture: led_candidate_data?.AreaArchitecture || "",
        AreaSDK: led_candidate_data?.AreaSDK || "",
        AreaReport: led_candidate_data?.AreaReport || "",
        AreaAdministration: led_candidate_data?.AreaAdministration || "",
        AreaOtherSkill: led_candidate_data?.AreaOtherSkill || "",
        WillingToTravel: led_candidate_data?.WillingToTravel || "",
        CandidateReferralType_174: selected_source,
        WorkDomainIDs: led_candidate_data?.WorkDomainIDs || "",
        LeadCandidateStatus_189:
          led_candidate_data?.LeadCandidateStatus_189 || "",
        ResumeBasePath: led_candidate_data?.ResumeBasePath || "",
        ResumePath: led_candidate_data?.ResumePath || "",
        NoticePeriod: selected_notice_period || "",
        NoticePeriodExtractedText: led_candidate_data?.NoticePeriodText || "",
        SkillSet: selectedSkills || "",
        SubSkillSet: subSkillSetArray || "",
        SubSkill: subSkillSetArray || "",
        referralType: selectedReferralType || "",
      };
      setFileName(led_candidate_data?.ResumePath || "");
      setFileUrl(led_candidate_data?.ResumeBasePath || "");
      setFormData(formDataEdit);
      setJsonData(response?.data?.data?.projectworkingDomain);
      setSelectedOptions(led_candidate_data.WorkDomainIDs);
      setStatusOption(led_candidate_data.LeadCandidateStatus_189 || 47);
      setStatusData(response?.data?.data?.candidatestatus);
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      console.error("Error fetching skill options:", error);
    }
  };

  const parseSelectedOptions = (dataString, options) => {
    return (dataString?.split(",") || [])
      .map((id) => options.find((option) => option.value === Number(id)))
      .filter(Boolean);
  };

  useEffect(() => {
    if (formData.SkillSet && formData.SkillSet.length > 0) {
      // Extract the 'value' from each selected option
      const selectedValues = formData.SkillSet.map((option) => option?.value);

      // Join the selected values into a comma-separated string
      const skillValues = selectedValues.join(",");
      // Fetch sub-skill options with the comma-separated values
      // fetchSubSkillOptions(skillValues);
    } else {
      setsubSkillOptions([]);
      setFormData((prevFormData) => ({
        ...prevFormData,
        SubSkillSet: "",
      }));
    }
  }, [formData.SkillSet]);

  // const fetchSubSkillOptions = async (skill_id) => {
  //   try {
  //     let data = { skillId: skill_id };
  //     const response = await PostServiceCaller(
  //       API_URL + "fetch-subskils",
  //       data,
  //       "post"
  //     );
  //     const subSkillData = response.data;
  //     const options = subSkillData.map((subSkill) => ({
  //       value: subSkill.ID,
  //       label: subSkill.SubSkill,
  //     }));
  //     // options.push(...formData.SubSkillSet);
  //     setsubSkillOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching subSkill options:", error);
  //   }
  // };

  const handleSkillChange = async (selectedOptions) => {
    let skill = selectedOptions[selectedOptions.length - 1];

    let skillSetArray = formData?.SkillSet || [];
    if (skill?.value) {
      skillSetArray.push(skill);
    }
    setFormData({ ...formData, SkillSet: skillSetArray });
    // fetchSubSkillOptions(skill?.value);
  };

  const handleSubSkillChange = (selectedOptions) => {
    let subSkill = selectedOptions[selectedOptions.length - 1];
    let SubSkillSetArray = formData?.SubSkillSet || [];
    if (subSkill?.value) {
      SubSkillSetArray.push(subSkill);
    }

    setFormData({ ...formData, SubSkillSet: SubSkillSetArray });
  };

  const [fileUrl, setFileUrl] = useState(null);
  const [file, setFile] = useState(null);

  // const handleFile = async (file) => {
  //   const selectedFile = file instanceof File ? file : file[0];

  //   if (file) {
  //     const allowedTypes = [
  //       "application/pdf",
  //       "application/msword",
  //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     ];

  //     if (!allowedTypes.includes(file.type)) {
  //       const errMsg = "Only PDF and Word files are allowed.";
  //       setErrors((errors) => ({
  //         ...errors,
  //         resume: { message: errMsg },
  //       }));
  //       toast.error(errMsg);
  //       return;
  //     }

  //     if (file.size > 1024 * 1024) {
  //       const errMsg = "File size should not exceed 1MB.";
  //       setErrors((errors) => ({
  //         ...errors,
  //         resume: { message: errMsg },
  //       }));
  //       toast.error(errMsg);
  //       return;
  //     }

  //     setErrors((errors) => ({
  //       ...errors,
  //       resume: { message: "" },
  //     }));

  //     setFileName(file.name);
  //     setResumeFile(file);
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       ResumePath: file.name,
  //     }));

  //     const url = URL.createObjectURL(selectedFile);
  //     setFileUrl(url);

  //     setFile(selectedFile);
  //     setFileName(selectedFile.name);
  //   } else {
  //     const errMsg = "Please select a file.";
  //     setErrors((errors) => ({
  //       ...errors,
  //       resume: { message: errMsg },
  //     }));
  //     toast.error(errMsg); // 🔥 show toast
  //   }
  // };

  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);
  const handleDropdownChange = async (e, name) => {
    const { value } = typeof e?.target == "undefined" ? e : e?.target;
    const updatedFormData = {
      ...formData,
      [name]: typeof e?.target == "undefined" ? e : value,
    };
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: { status: false, message: "" },
    }));
    if (name === "CandidateReferralType_174") {
      updatedFormData.referralType = null;
      setErrors((prevErrors) => ({
        ...prevErrors,
        referralType: { status: false, message: "" },
      }));
    }

    setFormData(updatedFormData);
    const inputStateMap = {
      2037: setShowOthersInput,
      6768: setShowCampusInput,
      2034: setShowJobPortalInput,
    };

    Object.keys(inputStateMap).forEach((key) => {
      const setter = inputStateMap[key];
      setter(value == key);
    });

    if (name == "CandidateReferralType_174") {
      let inputStateMap = [2035, 2034, 2037, 6768, 2036];
      let label = ["Reference", "Job Portal", "Others", "Campus", "Vendor"];

      let selected = inputStateMap.indexOf(value);
      if (selected >= 0) {
        const response = await GetServiceCaller(
          API_URL + "get-referred-by-value/" + value
        );
        const referrealsOptions = response?.data?.referrals?.map((option) => ({
          value: option.VALUE,
          label: option.TEXT,
        }));
        setReferrals([{ label: "Select...", value: "" }, ...referrealsOptions]);
        setReferralInput({
          show: true,
          label: label[selected],
          placeholder: label[selected],
        });
      } else {
        setReferralInput({ show: false, label: "", placeholder: "" });
      }
    }
  };

  const checkIfInArray = (value) => {
    let array = formData?.WorkDomainIDs?.split(",") || [];
    let text = "";
    for (let i = 0; i < array?.length; i++) {
      if (array[i] == value) {
        text = "checked";
      }
    }
    return text;
  };

  useEffect(() => {
    fetchData(id);
  }, []);

  const handleOptionChange = (event) => {
    setStatusOption(parseInt(event.target.value));
  };
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  const customStyle = {
    // for control
    control: (provided, state) => ({
      ...provided,
      height: "70px",
      overflow: "scroll",
    }),
    //for common cross icon
    multiValueRemove: (base, state) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#22ACD3",
        color: "white",
      },
    }),
    //for  dropdown icon
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "0px",
    }),
    //for dropdown conatiner
    indicatorsContainer: (provided, state) => ({
      ...provided,
      width: "28px",
      height: "34px",
      marginTop: "9px",
    }),
  };

  // code for Subskill
  const parseSkills = (data) => {
    if (!data) return [];
    return data
      .split(",")
      .map((skill) => skill.trim())
      .filter((skill) => skill.length > 0);
  };
  const skillsToString = (skillsArray) => {
    return skillsArray.join(", ");
  };
  const skills = parseSkills(formData.SubSkill);

  const handleYes = async (e) => {
    e.preventDefault();
    setSubmit(true);
    try {
      const confirmResponse = await PostFormServiceCaller(
        API_URL + "ai-parsed-candidate-details/" + id,
        { ...pendingFormData, flag: 1 },
        "put"
      );

      if (confirmResponse?.data?.status === "success") {
        setSubmit(false);
        if (statusOption === 46) {
          navigate("/hrinterviews");
        } else if (statusOption === 47) {
          navigate("/candidate-in-process");
        } else {
          navigate("/resume-parser");
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setShowConfirmModal(false);
      setSubmit(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <form id="formOne" className="rounded mt-2 bg-white">
            <div className="container-fluid">
              {/* tab code start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="job-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#job"
                    type="button"
                    role="tab"
                    aria-controls="job"
                    aria-selected="true"
                  >
                    Job Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="personal-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#personal"
                    type="button"
                    role="tab"
                    aria-controls="personal"
                    aria-selected="false"
                  >
                    Personal Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="project-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#project"
                    type="button"
                    role="tab"
                    aria-controls="project"
                    aria-selected="false"
                  >
                    Last Employement Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="rating-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#rating"
                    type="button"
                    role="tab"
                    aria-controls="rating"
                    aria-selected="false"
                  >
                    Rating
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="other-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#other"
                    type="button"
                    role="tab"
                    aria-controls="other"
                    aria-selected="false"
                  >
                    Other Details
                  </button>
                </li>
              </ul>
              {/* tab main section code start */}
              <div className="tab-content" id="myTabContent">
                {/* Job Details Section */}
                <div
                  className="tab-pane fade show active"
                  id="job"
                  role="tabpanel"
                  aria-labelledby="job-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-md-6 col-lg-4">
                        <label className="form-label">
                          Job Title <span className="required">*</span>
                        </label>
                        <Select
                          options={jobtitleOption}
                          onChange={(selected) => {
                            handleDropdownChange(selected, "JobMasterID");
                          }}
                          selected={selectedJobTitle}
                          value={formData?.JobMasterID}
                          name="JobMasterID"
                        />
                        {errors?.JobMasterID?.status && (
                          <span className="error">
                            {errors?.JobMasterID?.message}
                          </span>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4">
                        <label className="form-label">
                          Applied Date
                          <span className="required">*</span>
                        </label>
                        <ReactDatePicker
                          showYearDropdown
                          showPopperArrow
                          showIcon
                          icon="fa fa-calendar"
                          className="form-control"
                          placeholderText="To Date"
                          format="DD-MMM-YYYY"
                          name="AppliedDate"
                          id="AppliedDate"
                          onChange={(date) =>
                            handleDateChange(date, "AppliedDate")
                          }
                          value={formData.AppliedDate}
                        />
                        {errors?.AppliedDate?.status && (
                          <span class="error">
                            {errors?.AppliedDate?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <label className="form-label">
                          HR Name <span className="required">*</span>
                        </label>
                        <Select
                          onChange={(selected) => {
                            handleDropdownChange(selected, "hr");
                          }}
                          value={formData.RecruiterID}
                          name="RecruiterID"
                          options={hrOptions}
                        />
                        {errors?.RecruiterID?.status && (
                          <span class="error">
                            {errors?.RecruiterID?.message}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-8">
                        <label className="form-label">Candidate Resume Summary</label>
                        <textarea
                          className="form-control"
                          name="CurrentJobDescription"
                          value={formData.CurrentJobDescription}
                          rows={8}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Personal Details Section */}
                <div
                  className="tab-pane fade show"
                  id="personal"
                  role="tabpanel"
                  aria-labelledby="personal-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-lg-9 mt-2">
                        <div className="row">
                          <div className="col-md-4">
                            <label className="form-label">
                              First Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="First Name"
                              className="form-control"
                              id="FirstName"
                              name="FirstName"
                              onChange={handleChange}
                              value={formData.FirstName}
                            />
                            {errors?.FirstName?.status && (
                              <span class="error">
                                {errors?.FirstName?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Last Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              className="form-control"
                              id="LastName"
                              name="LastName"
                              onChange={handleChange}
                              value={formData.LastName}
                            />
                            {errors?.LastName?.status && (
                              <span class="error">
                                {errors?.LastName?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Gender<span className="required">*</span>
                            </label>
                            <Select
                              name="Gender"
                              options={gender_option}
                              value={formData.Gender}
                              onChange={(selected) =>
                                handleDropdownChange(selected, "Gender")
                              }
                            ></Select>
                            {errors.Gender && (
                              <span className="error">
                                {errors.Gender.message}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-4">
                            <label className="form-label">DOB</label>
                            <CustomDatePicker
                              handleChange={handleChange}
                              value={formData.DateOfBirth}
                              name="DateOfBirth"
                              id="DateOfBirth"
                              className="form-control"
                              placeholderText="Date Of Birth"
                              maxDate={new Date()}
                            ></CustomDatePicker>
                            {/* {errors?.DateOfBirth?.status && (
                              <span class="error">
                                {errors?.DateOfBirth?.message}
                              </span>
                            )} */}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Contact No.
                              <span className="required">*</span>
                            </label>
                            <input
                              className="form-control"
                              onBlur={handleEmailMobileVerify}
                              name="MobileNo"
                              value={formData.MobileNo ? formData.MobileNo : ""}
                              onChange={handleChange}
                              disabled={
                                !(
                                  formData.MobileNo === 0 ||
                                  formData.MobileNo === ""
                                )
                              }
                              placeholder="Contact No."
                            />
                            {errors?.MobileNo?.status && (
                              <span class="error">
                                {errors?.MobileNo?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Alternate Contact No.
                            </label>
                            <input
                              className="form-control"
                              name="MobileNo1"
                              value={
                                formData.MobileNo1
                                  ? formData.MobileNo1.toString()
                                  : ""
                              }
                              onChange={handleChange}
                              placeholder="Contact No."
                            />
                            {errors?.MobileNo1?.status && (
                              <span class="error">
                                {errors?.MobileNo1?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4 mt-3">
                            <label htmlFor="EmailID" className="form-label">
                              Email ID
                              <span className="required">*</span>
                            </label>
                            <input
                              type="EmailID"
                              onBlur={handleEmailMobileVerify}
                              disabled={
                                !(
                                  formData.EmailID === 0 ||
                                  formData.EmailID === ""
                                )
                              }
                              placeholder="Email Id"
                              className="form-control"
                              id="EmailID"
                              name="EmailID"
                              onChange={handleChange}
                              value={formData.EmailID}
                            />
                            {errors?.EmailID?.status && (
                              <span class="error">
                                {errors?.EmailID?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4 mt-3">
                            <label className="form-label">Qualification</label>
                            <input
                              type="text"
                              placeholder="Qualifications"
                              class="form-control"
                              id="Qualifications"
                              name="Qualifications"
                              onChange={handleChange}
                              value={formData.Qualifications}
                            />
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-4">
                            <RatingComponentWithoutNa
                              label="Introduction"
                              name="IntroduceYourself"
                              value={formData.IntroduceYourself}
                              onChange={(value) =>
                                handleRatingChange("IntroduceYourself", value)
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <RatingComponentWithoutNa
                              label="Oral Skills"
                              name="OralSkills"
                              value={formData.OralSkills}
                              onChange={(value) =>
                                handleRatingChange("OralSkills", value)
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <RatingComponentWithoutNa
                              label="Accent"
                              name="Accent"
                              value={formData.Accent}
                              onChange={(value) =>
                                handleRatingChange("Accent", value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="col-md-12 mt-2">
                          <label className="form-label">
                            Skill Sets<span className="required">*</span>
                          </label>
                          <Select
                            isMulti
                            name="SkillSet"
                            options={skillsetOptions}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(selectedOptions) => {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                SkillSet: { status: false, message: "" },
                              }));
                              setFormData({
                                ...formData,
                                SkillSet: selectedOptions,
                              });
                            }}
                            value={formData.SkillSet}
                            styles={customStyle}
                          />
                          {errors?.SkillSet?.status && (
                            <span class="error">
                              {errors?.SkillSet?.message}
                            </span>
                          )}
                        </div>
                        <div className="col-md-12 mt-3">
                          <div className="mb-3">
                            <label className="form-label">Sub Skill</label>
                            <div
                              className="form-control d-flex flex-wrap gap-2 p-2"
                              style={{
                                minHeight: "96px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                overflowX: "hidden",
                              }}
                            >
                              {skills.map((skill, index) => (
                                <div
                                  key={index}
                                  className="badge rounded-1 d-inline-flex align-items-center px-2 py-1"
                                  style={{
                                    backgroundColor: "#27568B",
                                    height: "20px",
                                  }}
                                >
                                  <span className="me-2 fw-normal">
                                    {skill}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Last Employee & Project Details section */}
                <div
                  className="tab-pane fade show"
                  id="project"
                  role="tabpanel"
                  aria-labelledby="project-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          placeholder="Company Name"
                          class="form-control"
                          id="CurrentCompanyName"
                          name="CurrentCompanyName"
                          onChange={handleChange}
                          value={formData.CurrentCompanyName}
                        />
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Designation
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Designation"
                          class="form-control"
                          id="CurrentPosition"
                          name="CurrentPosition"
                          onChange={handleChange}
                          value={formData.CurrentPosition}
                        />
                        <span class="error">
                          {errors?.CurrentPosition?.message}
                        </span>
                      </div>

                      <div className="col-md-6 col-lg-2">
                        <Form.Label>
                          Notice Period(in Days) (
                          {formData?.NoticePeriodExtractedText || ""})
                        </Form.Label>
                        <Select
                          class="form-select"
                          aria-label="Default select example"
                          onChange={(selected) =>
                            handleDropdownChange(selected, "NoticePeriod")
                          }
                          name="NoticePeriod"
                          value={formData.NoticePeriod}
                          options={notice_period}
                        ></Select>
                      </div>
                      <div className="col-md-6 col-lg-2 ">
                        <label
                          htmlFor="MinExperience"
                          className="form-label  "
                        >
                          Total Experience
                        </label>
                        <div className="row">
                          <div className="col-sm-6">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  Exp. in yrs
                                </Tooltip>
                              }
                            >
                              <input
                                type="number"
                                placeholder="Experience"
                                class="form-control text-end"
                                id="CurrentExperienceInYears"
                                name="CurrentExperienceInYears"
                                onChange={handleChange}
                                value={formData.CurrentExperienceInYears}
                              />
                            </OverlayTrigger>
                          </div>
                          <div className="col-6">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  Rel. Exp. In Yrs
                                </Tooltip>
                              }
                            >
                              <input
                                type="number"
                                placeholder="Relevant Experience"
                                className="form-control text-end"
                                id="CurrentRelevantExperienceInYears"
                                name="CurrentRelevantExperienceInYears"
                                onChange={handleChange}
                                value={
                                  formData.CurrentRelevantExperienceInYears
                                }
                              />
                            </OverlayTrigger>
                          </div>
                        </div>

                      </div>
                      <div className="col-md-6 col-lg-2">
                        <label htmlFor="CTC" className="form-label  ">
                          CTC
                        </label>
                        <div className="row">
                          <div className="col-sm-6">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  CTC (in Rupees)
                                </Tooltip>
                              }
                            >
                              <input
                                type="number"
                                className="form-control text-end"
                                id="CurrentCTC"
                                name="CurrentCTC"
                                onChange={handleChange}
                                value={formData.CurrentCTC}
                                placeholder="CTC"
                              />
                            </OverlayTrigger>
                          </div>
                          <div className="col-6">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  Expected CTC (in Rupees)
                                </Tooltip>
                              }
                            >
                              <input
                                type="number"
                                className="form-control text-end"
                                id="ExpectedCTC"
                                name="ExpectedCTC"
                                onChange={handleChange}
                                value={formData.ExpectedCTC}
                                placeholder="ECTC"
                              />
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">


                      <div className="col-md-12 col-lg-12">
                        <div class="col-md-12">
                          <Form.Group className="col-form-label">
                            <Form.Label>Work Details</Form.Label>
                            <Editor
                              onEditorChange={handleEditorChangeNoOfProject}
                              data={formData.ProjectOtherDesc}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="col-md-12">
                          <Form.Label>
                            2. Which domains have you worked in?
                          </Form.Label>
                          <div class="col-md-12 mt-2">
                            <div className="row">
                              {jsonData &&
                                jsonData.map((item) => (
                                  <div
                                    key={item.value}
                                    className="col-md-6 col-lg-3"
                                  >
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={item.value}
                                        value={item.value}
                                        checked={checkIfInArray(item.value)}
                                        onChange={() =>
                                          handleCheckboxChange(item.value)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={item.value}
                                      >
                                        {item.text}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rating Section start */}
                <div
                  className="tab-pane fade show"
                  id="rating"
                  role="tabpanel"
                  aria-labelledby="rating-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div class="mt-2">
                            <RatingComponent
                              label="Dashboard Development"
                              name="AreaDashboard"
                              value={formData.AreaDashboard}
                              onChange={(value) =>
                                handleRatingChange("AreaDashboard", value)
                              }
                            />
                          </div>
                          <div class="mt-4">
                            <RatingComponent
                              label="Architecture"
                              name="AreaArchitecture"
                              value={formData.AreaArchitecture}
                              onChange={(value) =>
                                handleRatingChange("AreaArchitecture", value)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div class="mt-2">
                            <RatingComponent
                              label="SDK"
                              name="AreaSDK"
                              value={formData.AreaSDK}
                              onChange={(value) =>
                                handleRatingChange("AreaSDK", value)
                              }
                            />
                          </div>
                          <div class="mt-4">
                            <RatingComponent
                              label="Report Development"
                              name="AreaReport"
                              value={formData.AreaReport}
                              onChange={(value) =>
                                handleRatingChange("AreaReport", value)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div class="mt-2">
                            <RatingComponent
                              label="Administration"
                              name="AreaAdministration"
                              value={formData.AreaAdministration}
                              onChange={(value) =>
                                handleRatingChange("AreaAdministration", value)
                              }
                            />
                          </div>
                          <div class="mt-4">
                            <RatingComponent
                              label="Other Skills"
                              name="AreaOtherSkill"
                              value={formData.AreaOtherSkill}
                              onChange={(value) =>
                                handleRatingChange("AreaOtherSkill", value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other details section */}
                <div
                  className="tab-pane fade show"
                  id="other"
                  role="tabpanel"
                  aria-labelledby="other-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group d-flex flex-column">
                          <label className="form-label">
                            Willing To Travel
                          </label>
                          <div className="d-flex gap-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="Yes"
                                value="Yes"
                                onChange={handleRadioChange}
                                checked={
                                  formData.WillingToTravel == "Yes"
                                    ? true
                                    : false
                                }
                              />
                              <label className="form-check-label" htmlFor="Yes">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="no"
                                value="No"
                                onChange={handleRadioChange}
                                checked={
                                  formData.WillingToTravel == "No"
                                    ? true
                                    : false
                                }
                              />
                              <label className="form-check-label" htmlFor="no">
                                No
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="occasionally"
                                value="Occasionally"
                                onChange={handleRadioChange}
                                checked={
                                  formData.WillingToTravel == "Occasionally"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="occasionally"
                              >
                                Occasionally
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group">
                          <label
                            htmlFor="CurrentLocation"
                            className="form-label"
                          >
                            Current Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="CurrentLocation"
                            name="CurrentLocation"
                            onChange={handleChange}
                            value={formData.CurrentLocation}
                            placeholder="Current Location"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group">
                          <label
                            htmlFor="PreferredLocation"
                            className="form-label"
                          >
                            Joining Location<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="PreferredLocation"
                            name="PreferredLocation"
                            onChange={handleChange}
                            value={formData.PreferredLocation}
                            placeholder="Preferred Location"
                          />
                          {errors?.PreferredLocation?.status && (
                            <span class="error">
                              {errors?.PreferredLocation?.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group">
                          <label
                            htmlFor="ReasonForChange"
                            className="form-label"
                          >
                            Reason For Change
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ReasonForChange"
                            name="ReasonForChange"
                            onChange={handleChange}
                            value={formData.ReasonForChange}
                            placeholder="Reason"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-lg-3 mt-2">
                        <div className="form-group">
                          <label htmlFor="ReferralNote" className="form-label">
                            Note
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ReferralNote"
                            name="ReferralNote"
                            onChange={handleChange}
                            value={formData.ReferralNote}
                            placeholder="Note"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <Form.Group className="col-form-label">
                          <Form.Label>
                            Source<span className="required">*</span>
                          </Form.Label>
                          <Select
                            name="CandidateReferralType_174"
                            options={source_option}
                            onChange={async (e) =>
                              await handleDropdownChange(
                                e,
                                "CandidateReferralType_174"
                              )
                            }
                            value={formData.CandidateReferralType_174}
                          />
                          <span class="error">
                            {errors?.CandidateReferralType_174?.message}
                          </span>
                        </Form.Group>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        {refferralDetails.show && (
                          <Form.Group className="col-form-label">
                            <label htmlFor="jobportal" className="form-label">
                              {refferralDetails.label}
                            </label>
                            <Select
                              name="referralType"
                              options={referrals}
                              onChange={(e) => {
                                handleDropdownChange(e, "referralType");
                              }}
                              placeholder={refferralDetails.placeholder}
                              value={formData.referralType}
                            />
                          </Form.Group>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3 mt-2">
                        <span className="m-0 p-0">
                          <b>Resume</b>
                        </span>
                        {/* <FileUploader
                          isRequired={true}
                          buttonLabel={"Resume"}
                          handleFile={handleFile}
                          accept=".pdf,.doc,.docx"
                        /> */}
                        {FileName && (
                          <div className="mt-2">
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {FileName}
                            </a>
                          </div>
                        )}
                        <span class="error">{errors?.resume?.message}</span>
                      </div>
                    </div>
                    <div className="col-sm-12 d-flex justify-content-center mt-4">
                      <label
                        htmlFor="LeadCandidateStatus_189"
                        className="form-label me-4"
                      >
                        Status:<span className="required">*</span>
                      </label>
                      {statusData.map((option) => (
                        <div
                          key={option.value}
                          className="form-check form-check-inline"
                        >
                          <input
                            // disabled={candidateProcessed ? true : false}
                            className="form-check-input"
                            type="radio"
                            id={option.value}
                            name="optionStatus"
                            value={option.value}
                            checked={statusOption == option.value}
                            onChange={handleOptionChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={option.value}
                          >
                            {option.text}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="text-center">
                      <strong>Note:</strong>{" "}
                      <span className="text-warning">
                        {statusOption === 46 &&
                          "If Status is Hold, the application moves to the New Application page."}
                        {statusOption === 47 &&
                          "If Status is Selected, the application moves to Candidate in Process stage."}
                        {statusOption === 1401 &&
                          "If Status is Rejected, The resume cannot be carried forward to the subsequent stage."}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="row row-flex">
                <div className="col-md-8 flex-col mt-1"></div>

                <div className="container d-flex justify-content-end mt-2">
                  <button
                    className="cancel-btn me-2"
                    onClick={() => navigate("/resume-parser")}
                  >
                    Cancel
                  </button>

                  <button
                    disabled={submitted ? true : false}
                    onClick={handleSubmit}
                    type=""
                    className="custom-btn"
                  >
                    {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        {showConfirmModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-md"
              role="document"
            >
              <div className="modal-content">
                {/* Header */}
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >
                    Confirmation
                  </p>
                  <span className="me-2">
                    <i
                      className="bi bi-x-lg"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowConfirmModal(false)}
                    ></i>
                  </span>
                </div>

                {/* Body */}
                <div className="modal-body">
                  <p style={{ margin: 0 }}>
                    This candidate already exists in Candidate In Process.
                    Proceeding will change the status to pending and overwrite
                    current details with the resume data. Do you want to
                    continue?
                  </p>
                </div>

                {/* Footer */}
                <div
                  className="modal-footer"
                  style={{
                    borderTop: "1px solid #f0f0f0",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    type="button"
                    className="cancel-btn me-2"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="custom-btn"
                    onClick={handleYes}
                  >
                    {submitted ? <FaSpinner class="sm-spinner" /> : "Yes"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
};

export default ResumeParserEdit;
